//Componentes generales
import React, { useState, useEffect } from "react";
import moment from "moment";

//Tipos de Prioridades
import { PRIORITY, PRIORITYIN } from '../../utils/priority';

//Permisos
import { EDITAR_NOTAS_PRIVADAS } from "../../utils/permisos";

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faXmark,
    faBox,
    faRotateRight,
    faFilePdf,
    faDownload,
    faPen,
    faRectangleXmark,
    faFloppyDisk,
    faSmile,
    faListCheck,
    faCheck,
    faTriangleExclamation,
    faThumbsDown,
    faCheckDouble,
    faCartShopping
} from "@fortawesome/free-solid-svg-icons";

//Estilos
import './ReqInfo.css';
import { COLOR_FONDO } from "../../constants/colors";

/* 
    Componente encargado de mostrar el detalle del requerimiento.
        Donde item es el requerimiento seleccionado.
              files son los archivos adjuntados al requerimiento.
              cerrar es la función encargada de ocultar el dialogo.
              verDetalle es la función del context que recupera los productos del requerimiento.
              repetir es una función que llama al componente que corresponda.
              generaPDF es una función que llama al componente que corresponda.
              abrirURL es la función encargada de abrir en una nueva ventana el archivo seleccionado.
              guardarModificaciones es la función del context que guarda el requerimiento en el caso de haber modificaciones.
              usuario es el usuario en sesión.

*/
function ReqInfo({ item = {}, files, cerrar, verDetalle, repetir, generaPDF, abrirURL, guardarModificaciones, usuario }) {
    
    //state de productos.
    const [products, setProducts] = useState([]);

    //state de requerimiento.
    const [requerimiento, setRequerimiento] = useState(item);
    
    //state para edición de nota.
    const [editNota, setEditNota] = useState(false);
    //state para edición de nota privada.
    const [editNotaReservada, setEditNotaReservada] = useState(false);
    //state para edición de prioridad.
    const [editPrioridad, setEditPrioridad] = useState(false);
    //state para indicar nota ya editada.
    const [editadoNota, setEditadoNota] = useState(false);
    //state para indicar nota reservada ya editada.
    const [editadoNotaReservada, setEditadoNotaReservad] = useState(false);

    /*
        Al renderizar el componente, recupera los productos del requerimiento seleccionado.
    */
    useEffect(() => {
        async function fp() {
            try {
                const p = await verDetalle(item.tDocCodFor, item.tDocNroFor);
                setProducts(p);
            } catch (error) {
                console.log("error");
            }
        }
        fp();
    }, []);

    /*
        Disparador que se activa al detectar algun cambio en el item. Setea el requerimiento con el item que fue modificado.
    */
    useEffect(() => {
        setRequerimiento(item);
    }, [item]);

    /*
        Manejador que descargar/abre todos los archivos adjuntados al requerimiento. 
    */
    const handleDownloadAll = () => {
        files.map((file) => (abrirURL(file.url)));
    }

    /* 
        Manejador que determina si habilitar o no la edición del campo Nota.
    */
    const handleEditNota = () => {
        setEditNota(!editNota);
    }

    /* 
        Manejador que determina si habilitar o no la edición del campo Nota Reservada.
    */
    const handleEditNotaReservada = () => {
        setEditNotaReservada(!editNotaReservada);
    }

    /* 
        Manejador que determina si habilitar o no la edición de la prioridad.
    */
    const handleEditPrioridad = () => {
        setEditPrioridad(!editPrioridad);
    }

    /* 
        Manejador ante cambio en casilla de Nota.
            Donde valor es lo ingresado por el usuario.
    */
    const handleModificaNota = (valor) => {
        setRequerimiento({ ...requerimiento, notePubl: valor });
        setEditadoNota(true);
    }

    /* 
        Manejador ante cambio en casilla de Nota Reservada.
            Donde valor es lo ingresado por el usuario.
    */
    const handleModificaNotaReservada = (valor) => {
        setRequerimiento({ ...requerimiento, notePriv: valor });
        setEditadoNotaReservad(true);
    }

    /* 
        Manejador ante cambio en la prioridad.
            Donde valor es lo seleccionado por el usuario.
    */
    const handleModificaPrioridad = (valor) => {
        const req_temp = { ...requerimiento, priority: valor };
        setRequerimiento(req_temp);
        setEditPrioridad(false);
        guardarModificaciones(req_temp, {priority: valor});
    }

    /* 
        Guarda el requerimiento mediante función del context.
    */
    const saveChanges = async () => {
        setEditNota(false);
        setEditNotaReservada(false);
        setEditPrioridad(false);
        let obj = {};
        if(editadoNota){
            obj = {notePubl: requerimiento.notePubl}
        }
        if(editadoNotaReservada){
            obj = {notePriv: requerimiento.notePriv}
        }

        const resp = await guardarModificaciones(requerimiento, obj);
        setRequerimiento(resp);
    }

    useEffect(()=>{
        //Calcula la diferencia entre las distintas fechas del RQ para calcular su Ciclo de Vida.
        let fechaAlta = moment(requerimiento.fecAlt).utc();
        let fechaEntrega = moment(requerimiento.deliveryDate).utc();
        let fechaCompletada = moment(requerimiento.fechaCompletado).utc();

        let difEntregaAlta = fechaEntrega.startOf('day').diff(fechaAlta.startOf('day'),'days');
        let difCompletadaEntrega = fechaCompletada.startOf('day').diff(fechaEntrega.startOf('day'),'days');
        let cicloVida = difEntregaAlta + difCompletadaEntrega;

        let req = {...requerimiento};
        req.diffAltaEntrega = difEntregaAlta;
        req.diffCompletadaEntrega = difCompletadaEntrega;
        req.cicloVida = cicloVida;
        setRequerimiento(req);
    },[item]);

    return (
        <div className='container-gr-req'>
            <div className='container-r-list-item-header-info'>
                <div className='label-req'>{requerimiento.tDocCodFor + ' - ' + requerimiento.tDocNroFor}</div>
                <div className='r-list-item-header-title'>{requerimiento.title}</div>
                {/* <div className={requerimiento.priority === 0 ? 'r-list-item-header-priority-media margin-right-r' : requerimiento.priority === 1 ? 'r-list-item-header-priority-alta margin-right-r' : 'r-list-item-header-priority-urgente margin-right-r'}>{PRIORITYOUT[requerimiento.priority]}</div> */}
                <div className='container-prioritys-gral'>
                    <div className={requerimiento.priority === 2 ? 'r-list-item-header-priority-urgente  margin-right-r' : requerimiento.priority === 1 ? 'r-list-item-header-priority-alta  margin-right-r' : 'r-list-item-header-priority-media  margin-right-r'} onClick={handleEditPrioridad}>
                        {PRIORITY[requerimiento.priority ? requerimiento.priority : 0]}
                    </div>
                    {editPrioridad &&
                        <div className='options-container-reqinfo' >
                            <div className='options-container-fr-back'>
                                {PRIORITY.map((prior) => {
                                    return (
                                        <div key={prior} className={PRIORITYIN[prior] === 2 ? 'r-list-item-header-priority-urgente' : PRIORITYIN[prior] === 1 ? 'r-list-item-header-priority-alta' : 'r-list-item-header-priority-media'} value={prior} onClick={() => handleModificaPrioridad(PRIORITYIN[prior])}>{prior}</div>
                                    );
                                })}
                            </div>
                        </div>
                    }
                </div>
                <button className="minimizarBtn" onClick={() => cerrar(null)}>X</button>
            </div>
            <div className='container-r-item-details'>
                <div className='container-r-info-p'>
                    <div className='label-req-title'>Estado Actual </div><div className='r-list-item-details-clave-v'>{requerimiento.state}</div>
                    {
                        requerimiento.ultimaLectura && <>
                            <div className='label-req-title'>Lectura {requerimiento.fechaLectura} </div>
                            <div className='container-lecturas-req'>
                                <div className='r-list-item-details-clave-v'>{requerimiento.ultimaLectura}</div>
                                {requerimiento.ultimaLectura2 && <div className='r-list-item-details-clave-v'>{requerimiento.ultimaLectura2}</div>}
                            </div>
                        </>
                    }
                    {
                        (!requerimiento.ultimaLectura && requerimiento.fechaLectura) && <>
                            <div className='label-req-title'>Lectura </div>
                            <div className='r-list-item-details-clave-v'>{requerimiento.fechaLectura}</div>
                        </>
                    }
                    <div className='label-req-title'>Emitido por </div><div className='r-list-item-details-title-v'>{requerimiento.userName}</div>
                </div>
                <div className='container-r-item-title-details'>Info Adicional</div>
                <div className='container-r-texto'>
                    <div className='r-list-item-details-data-v'>{requerimiento.observ}</div>
                </div>
                <div className='container-r-item-title-details'>Fecha</div>
                <div className='calculosFechasDiv' style={{width:'100%'}}>  
                    <div className='container-r-fecha'>
                        <div className='fechasCalculadasDiv'>
                            <div className='label-req-fecha'>
                                Alta <div className='fechaLabel'>{moment(requerimiento.fecAlt).utcOffset(0).format('DD-MM-YYYY')}</div> 
                                {/* Alta <div className='fechaLabel'>{moment(requerimiento.fecAlt).format('DD-MM-YYYY')}</div>  */}
                            </div>          
                            <div className='label-req-fecha'>
                                Entrega Estimada <div className='fechaLabel'>{moment(requerimiento.deliveryDate).utcOffset(0).format('DD-MM-YYYY')}</div> 
                                {/* Entrega Estimada <div className='fechaLabel'>{moment(requerimiento.deliveryDate).format('DD-MM-YYYY')}</div>  */}
                            </div>
                            {(requerimiento.state == 'FINALIZADA' && requerimiento.fechaCompletado) && <div className='label-req-fecha'>
                                Completada <div className='fechaLabel'>{moment(requerimiento.fechaCompletado).format('DD-MM-YYYY')}</div> 
                            </div>}
                            <div className='indicador indicador1'>|</div>
                            {(requerimiento.state == 'FINALIZADA' && requerimiento.fechaCompletado)  && <div className='indicador indicador2'>|</div>}
                            <div className='difDias difDias1'>{requerimiento.diffAltaEntrega} días</div>
                            {(requerimiento.state == 'FINALIZADA' && requerimiento.fechaCompletado) && <div className='difDias difDias2'>{requerimiento.diffCompletadaEntrega} días</div>}
                            {(requerimiento.state == 'FINALIZADA' && requerimiento.fechaCompletado)  && <div className='difDias difDias3'>{requerimiento.cicloVida} días</div>}
                            {(requerimiento.state == 'FINALIZADA' && requerimiento.fechaCompletado)  && <div className='indicador indicador3'>|</div>}
                        </div>     
                    </div>
                </div>


                <div className='container-r-item-title-details'>Tareas: {(requerimiento.tareas != undefined) ? requerimiento.tareas.length : '0'}</div>
                <div className="container-list-products-r-gral">
                    {(requerimiento.tareas != undefined) && requerimiento.tareas.map((tarea) => {
                        return (
                            <div className="container-list-products-r" key={tarea.codRed}>
                                <div className="container-list-product-r-icon">
                                    <div className='list-item-icon-r'><FontAwesomeIcon icon={faListCheck} /></div>
                                    <div className="list-item-title-r">
                                        {tarea.codTarea} 
                                    </div>
                                </div>
                                <div className="container-list-products-r-details">
                                    <div>
                                        {tarea.descrp} {tarea.done && <FontAwesomeIcon icon={faCheck} style={{fontSize:"1.5rem", color:"green", fontWeight:"600"}}/>}
                                    </div>
                                    <div className="container-cantidad-product-r">
                                        Descripcion adicional: {tarea.taskDescrp}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className='container-r-item-title-details'>Materiales: {requerimiento.quantity}</div>
                <div className="container-list-products-r-gral">
                    {(requerimiento.products != undefined) && requerimiento.products.map((product) => {
                        return (
                            <div className="container-list-products-r" key={product.codRed}>
                                <div className="container-list-product-r-icon">
                                    <div className='list-item-icon-r'><FontAwesomeIcon icon={faBox} /></div>
                                    <div className="list-item-title-r">
                                        {product.codRed}
                                    </div>
                                </div>
                                <div className="container-list-products-r-details">
                                    <div>
                                        {product.descrp}
                                    </div>
                                    <div>
                                        {product.textAdic}
                                    </div>
                                    <div className="container-cantidad-product-r">
                                        Cantidad: {product.quantity}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className='container-r-item-title-details'>Imputaciones RRHH: {(requerimiento.imputaciones != undefined) ? requerimiento.imputaciones.length : '0'}</div>
                <div className="container-list-products-r-gral">
                    {(requerimiento.imputaciones != undefined) && requerimiento.imputaciones.map((impu) => {
                        return (
                            <div className="container-list-products-r" key={impu.codRed}>
                                <div className="container-list-product-r-icon">
                                    <div className='list-item-icon-r'><FontAwesomeIcon icon={faSmile} /></div>
                                    <div className="list-item-title-r">
                                        {impu.legajo.value}
                                    </div>
                                </div>
                                <div className="container-list-products-r-details">
                                    <div>
                                        {impu.legajo.label}
                                    </div>
                                    <div>
                                        {impu.textAdic}
                                    </div>
                                    <div className="container-cantidad-product-r">
                                        Cantidad Horas: {impu.cantHoras}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                
                <div className='container-r-item-title-details'>Proveedores: {(requerimiento.proveedores != undefined) ? requerimiento.proveedores.length : '0'}</div>
                <div className="container-list-products-r-gral">
                    {(requerimiento.proveedores != undefined) && requerimiento.proveedores.map((p) => {
                        return (
                            <div className="container-list-products-r" key={p.codRed}>
                                <div className="container-list-product-r-icon">
                                    <div className='list-item-icon-r'><FontAwesomeIcon icon={faCartShopping} /></div>
                                    <div className="list-item-title-r">
                                        {p.proveedor.value}
                                    </div>
                                </div>
                                <div className="container-list-products-r-details">
                                    <div>
                                        {p.proveedor.label}
                                    </div>
                                    <div>
                                        {p.textAdic}
                                    </div>
                                    <div className="container-cantidad-product-r">
                                        Importe: ${p.importe}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                
                <div className='container-r-item-title-details'>Controles Fallidos: {(requerimiento.controlesFallidos != undefined) ? requerimiento.controlesFallidos.length : '0'}</div>
                <div className="container-list-products-r-gral">
                    {(requerimiento.controlesFallidos != undefined) && requerimiento.controlesFallidos.map((ctrlFallido) => {
                        return (
                            <div className="container-list-products-r" key={ctrlFallido.codRed}>
                                <div className="container-list-product-r-icon">
                                    <div className='list-item-icon-r'><FontAwesomeIcon icon={faThumbsDown} style={{color:'red'}}/></div>
                                    <div className="list-item-title-r">
                                        {ctrlFallido.codControl}
                                    </div>
                                </div>
                                <div className="container-list-products-r-details">
                                    <div>
                                        {ctrlFallido.descrp}
                                    </div>
                                    <div className="container-cantidad-product-r">
                                        {ctrlFallido.textAdic}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                
                <div className='container-r-item-title-details'>Checklists Asociados: {(requerimiento.checklists != undefined) ? requerimiento.checklists.length : '0'}</div>
                <div className="container-list-products-r-gral">
                    {(requerimiento.checklists != undefined) && requerimiento.checklists.map((ck) => {
                        return (
                            <div className="container-list-products-r" key={ck.codRed}>
                                <div className="container-list-product-r-icon">
                                    <div className='list-item-icon-r'><FontAwesomeIcon icon={faCheckDouble}/></div>
                                    <div className="list-item-title-r">
                                        {ck.codChecklist}
                                    </div>
                                </div>
                                <div className="container-list-products-r-details">
                                    <div>
                                        {ck.checklist.label}
                                    </div>
                                    <div className="container-cantidad-product-r">
                                        Checklist Numero: {ck.nroChecklist}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className='container-r-item-title-details'>
                    <div>Nota</div>
                    {!editNota &&
                        <div className='container-button-download'><button className="button-edit" onClick={handleEditNota}><FontAwesomeIcon icon={faPen} /> </button></div>
                    }
                    {editNota &&
                        <div className='container-button-download'>
                            <button className="button-edit" onClick={handleEditNota}><FontAwesomeIcon icon={faRectangleXmark} /></button>
                            <button className="button-edit" onClick={saveChanges}><FontAwesomeIcon icon={faFloppyDisk} /></button>
                        </div>
                    }

                </div>
                <div className='container-r-texto'>
                    {!editNota &&
                        <div className='r-list-item-details-data-v'>{requerimiento.notePubl}</div>
                    }
                    {editNota &&
                        <textarea className='r-textarea-input' value={requerimiento.notePubl} onChange={(data) => handleModificaNota(data.target.value)} />
                    }
                </div>
                {usuario.userType.some(item => EDITAR_NOTAS_PRIVADAS.includes(item.typeName)) && (
                    <>
                        <div className='container-r-item-title-details'>
                            <div>Nota Reservada</div>
                            {!editNotaReservada &&
                                <div className='container-button-download'><button className="button-edit" onClick={handleEditNotaReservada}><FontAwesomeIcon icon={faPen} /> </button></div>
                            }
                            {editNotaReservada &&
                                <div className='container-button-download'>
                                    <button className="button-edit" onClick={handleEditNotaReservada}><FontAwesomeIcon icon={faRectangleXmark} /></button>
                                    <button className="button-edit" onClick={saveChanges}><FontAwesomeIcon icon={faFloppyDisk} /></button>
                                </div>
                            }
                        </div>
                        <div className='container-r-texto'>
                            {!editNotaReservada &&
                                <div className='r-list-item-details-data-v'>{requerimiento.notePriv}</div>
                            }
                            {editNotaReservada &&
                                <textarea className='r-textarea-input' value={requerimiento.notePriv} onChange={(data) => handleModificaNotaReservada(data.target.value)} />
                            }
                        </div>
                    </>
                )}
                <div className='container-r-item-title-details'>
                    <div>Archivos</div>
                    <div className='container-button-download'><button className="button-download" onClick={handleDownloadAll}>Descargar Todos <FontAwesomeIcon icon={faDownload} /> </button></div>
                </div>
                <div className='container-files-rq'>
                    <ul className='container-files-rq-details'>
                        {files?.map((file) => (
                            <li className="container-files-rq-details-items" key={file.name} onClick={() => abrirURL(file.url)}>{file.name}</li>
                        ))} 
                    </ul>
                </div>
            </div>
            <div className="rq-container-buttons-bottom">
                <div className="rq-button-bottom" onClick={() => generaPDF(requerimiento, 'Admin')} ><FontAwesomeIcon icon={faFilePdf} /> PDF</div>
                <div className="rq-button-bottom" onClick={() => generaPDF(requerimiento, 'Admin', true)} ><FontAwesomeIcon icon={faFilePdf} />PDF con Logo</div>
                <div className="rq-button-bottom" onClick={() => generaPDF(requerimiento, 'Admin', false, 'costos')} ><FontAwesomeIcon icon={faFilePdf} />PDF Costos</div>
            </div>
        </div>
    );
}

export default ReqInfo